import React, { ReactElement, useState } from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  ArrayField,
  Datagrid,
  useShowController,
  useNotify,
  NumberField,
  ImageField,
  UrlField,
} from "react-admin";
import { getApiService } from "shared/src/utils/api-service";
import { Permissions } from "../../providers/Interfaces";
import { ButtonWithLoadingSpinner } from "../Users/ScanMeasurements";

export const InsoleOverviewShow = ({
  permissions,
  ...props
}: {
  permissions: Permissions;
}): ReactElement => {
  const controllerProps = useShowController(props);
  const [isLoadingMesh, setIsLoadingMesh] = useState(false);
  const { record } = controllerProps;
  const notify = useNotify();

  const handleDownloadClick = async () => {
    setIsLoadingMesh(true);
    try {
      const zipBlob = await getApiService().fetchInsoleZip(record.id);
      saveAs(zipBlob, `${record.id}_insole_files.zip`);
      notify("Download erfolgreich gestartet", { type: "info" });
    } catch (error) {
      console.error("Download failed", error);
      notify("Download fehlgeschlagen. Bitte erneut versuchen.", {
        type: "warning",
      });
    } finally {
      setIsLoadingMesh(false);
    }
  };

  return (
    <Show {...props} resource="insoles">
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="user" />
        <ArrayField source="insolefiles">
          <Datagrid>
            <TextField source="side" label="Side" />
            <UrlField source="content" label="Insole" />
            <UrlField source="medial_support" label="medial_support" />
            <UrlField source="pelotte_support" label="pelotte_support" />
            <TextField source="processed_at" label="processed_at" />
          </Datagrid>
        </ArrayField>
        <ButtonWithLoadingSpinner
          loading={isLoadingMesh}
          handleClick={() => handleDownloadClick()}
        >
          Download Insole Files
        </ButtonWithLoadingSpinner>
      </SimpleShowLayout>
    </Show>
  );
};
